import * as yup from 'yup';
import { values } from '../enums';
import { RoleName } from '../security';

export const IRoleSchema = yup.object({
  name: yup.mixed<RoleName>().oneOf(values(RoleName)).required(),
  rights: yup.array(yup.string().required()).default([]),
});

export interface IRole {
  name: RoleName;
  rights: string[];
}
